import type { AxiosResponse } from "axios";

/**
 * レスポンスインターセプター
 * 403エラー（セッション期限切れによるアクセス不可）を一元的にハンドリング
 */
export const handleUnauthorizedResponse = (
  response: AxiosResponse,
): AxiosResponse => {
  // 403エラーの場合、カスタムイベントを発火してモーダル表示
  if (response.status === 403) {
    const currentPath = window.location.pathname;
    const url = response.config?.url || "";
    console.log(`AxiosResponse currentPath ${currentPath}, url ${url}`);

    // 除外条件: 以下の場合はモーダルを表示しない
    // 1. 初回アクセス時の未ログイン状態
    if (currentPath === "/" && url.includes("/api/get-current-user")) {
      return response;
    }
    // 2. ログアウトAPIの呼び出し
    if (url.includes("/api/logout")) {
      return response;
    }

    // カスタムイベントを発火（モーダル表示用）
    const event = new CustomEvent("session-expired");
    window.dispatchEvent(event);
  }

  // レスポンスはそのまま返す（throwしない）
  // これにより、後続のエラーハンドリング（catchErrorCodes）が正常に動作する
  return response;
};
